/* Norvu PDP island — vanilla JS, no React. Live-site parity. */
(function () {
  const root = document.querySelector('[data-pdp]');
  if (!root) return;
  try {

  const dataEl = document.getElementById('norvu-pdp-data');
  const metaEl = document.getElementById('norvu-product-meta');
  const data = dataEl ? JSON.parse(dataEl.textContent) : {};
  const allMeta = metaEl ? JSON.parse(metaEl.textContent) : {};
  const meta = allMeta[data.handle] || null;

  const fmt = (cents) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: data.currency || 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })
      .format((cents || 0) / 100);

  const fmt2 = (cents) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: data.currency || 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .format((cents || 0) / 100);

  /* ---- Hydrate meta ---- */
  if (meta) {
    const set = (sel, val) => {
      const els = root.querySelectorAll(`[data-meta="${sel}"]`);
      if (!els.length) return;
      els.forEach(el => {
        if (Array.isArray(val)) {
          if (sel === 'faqs') {
            el.innerHTML =
              '<div class="norvu-acc__group" data-acc-group>' +
              val.map(f =>
                `<details class="norvu-faq-line"><summary>${f.q}<span class="norvu-faq-line__icon" aria-hidden="true"></span></summary><div class="norvu-acc__body"><p>${f.a}</p></div></details>`
              ).join('') +
              '</div>';
          } else if (sel === 'actives') {
            el.innerHTML = val.map(a => `<li>${a}</li>`).join('');
          } else if (sel === 'ingredientsExpanded') {
            el.innerHTML = val.map(i => {
              const mapped = (window.NorvuAssetMap && window.NorvuAssetMap[i.img]) || '';
              const imgSrc = mapped || (i.img ? (window.NorvuAssetBase || '') + i.img : '');
              const img = imgSrc ? `<div class="norvu-pdp__hq-img"><img src="${imgSrc}" alt="${i.name}" loading="lazy" width="160" height="160"></div>` : '';
              return `<li>${img}<div class="norvu-pdp__hq-body"><h3>${i.name}</h3><p>${i.desc}</p></div></li>`;
            }).join('');
          } else if (sel === 'clinicalStats') {
            el.innerHTML = val.map(s => `
              ${s.group ? `<p class="norvu-pdp__clinical-group">${s.group}</p>` : ''}
              <div class="norvu-pdp__clinical-stat">
                <span class="norvu-pdp__clinical-num">${s.stat}</span>
                <p>${s.text}</p>
              </div>`).join('');
          } else {
            el.innerHTML = val.map(i => `<li>${i}</li>`).join('');
          }
        } else if (sel === 'bestSellerSpinner') {
          if (val) el.classList.add('is-on');
        } else if (sel === 'reviewCount' || sel === 'subtitle' || sel === 'stickyName' ||
                   sel === 'engineeredTitle' || sel === 'engineeredCopy' ||
                   sel === 'clinicalTitle' || sel === 'clinicalIntro' || sel === 'clinicalFootnote' ||
                   sel === 'ingredientsTitle' || sel === 'ingredientsIntro' ||
                   sel === 'benefitsJoined' || sel === 'whosItForCopy') {
          el.textContent = val;
        }
      });
    };
    Object.keys(meta).forEach(k => set(k, meta[k]));
    // bestSeller flag sets the spinner
    if (meta.bestSeller) {
      root.querySelectorAll('[data-meta="bestSellerSpinner"]').forEach(el => el.classList.add('is-on'));
    }
  }

  /* ---- Gallery (translate-based swipe carousel) ---- */
  const main = root.querySelector('[data-pdp-main]');
  const track = root.querySelector('[data-pdp-track]');
  const slides = root.querySelectorAll('[data-pdp-slide]');
  const dots = root.querySelectorAll('[data-pdp-dot]');
  let currentIndex = 0;

  const setIndex = (i) => {
    const max = slides.length - 1;
    if (max < 0) return;
    currentIndex = Math.max(0, Math.min(max, i));
    if (track) {
      track.style.transition = '';
      track.style.transform = `translate3d(${-currentIndex * 100}%, 0, 0)`;
    }
    dots.forEach(t => t.classList.toggle('is-active', t.dataset.index === String(currentIndex)));
    // Keep an .is-active class on the slide for any other code that wants it
    slides.forEach(s => s.classList.toggle('is-active', s.dataset.index === String(currentIndex)));
  };

  dots.forEach(t => t.addEventListener('click', () => setIndex(parseInt(t.dataset.index, 10) || 0)));

  if (main && track && slides.length > 1) {
    let startX = 0, startY = 0, currentX = 0, dragging = false, locked = null, slideW = 0;

    const onStart = (e) => {
      const t = e.touches ? e.touches[0] : e;
      startX = t.clientX; startY = t.clientY; currentX = startX;
      dragging = true; locked = null;
      slideW = main.getBoundingClientRect().width || 1;
      track.style.transition = 'none';
    };
    const onMove = (e) => {
      if (!dragging) return;
      const t = e.touches ? e.touches[0] : e;
      currentX = t.clientX;
      const dx = currentX - startX;
      const dy = (t.clientY - startY);
      if (locked === null) {
        // First meaningful move locks axis — if vertical wins, abort drag entirely
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
          locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
      }
      if (locked === 'x') {
        if (e.cancelable) e.preventDefault();
        // Resist drag at edges
        let pull = dx;
        if (currentIndex === 0 && dx > 0) pull = dx * 0.35;
        if (currentIndex === slides.length - 1 && dx < 0) pull = dx * 0.35;
        track.style.transform = `translate3d(calc(${-currentIndex * 100}% + ${pull}px), 0, 0)`;
      }
    };
    const onEnd = () => {
      if (!dragging) return;
      dragging = false;
      track.style.transition = 'transform .32s cubic-bezier(.4,0,.2,1)';
      if (locked !== 'x') {
        setIndex(currentIndex);
        return;
      }
      const dx = currentX - startX;
      const threshold = Math.max(40, slideW * 0.18);
      if (dx <= -threshold) setIndex(currentIndex + 1);
      else if (dx >= threshold) setIndex(currentIndex - 1);
      else setIndex(currentIndex);
    };

    main.addEventListener('touchstart', onStart, { passive: true });
    main.addEventListener('touchmove', onMove, { passive: false });
    main.addEventListener('touchend', onEnd, { passive: true });
    main.addEventListener('touchcancel', onEnd, { passive: true });
  }

  setIndex(0);

  /* ---- Variant picker ---- */
  const variantInput = root.querySelector('[data-pdp-variant-id]');
  const optBtns = root.querySelectorAll('[data-option-value]');
  const selectedOpts = data.variants[0] ? [...data.variants[0].options] : [];
  optBtns.forEach(btn => btn.addEventListener('click', () => {
    const i = +btn.dataset.optionIndex;
    selectedOpts[i] = btn.dataset.optionValue;
    root.querySelectorAll(`[data-option-index="${i}"]`).forEach(b =>
      b.classList.toggle('is-active', b.dataset.optionValue === btn.dataset.optionValue));
    const match = data.variants.find(v => v.options.every((o, idx) => o === selectedOpts[idx]));
    if (match) { variantInput.value = match.id; updatePricing(); }
  }));

  /* ---- Tier ---- */
  const tierEls = root.querySelectorAll('[data-tier]');
  const planInput = root.querySelector('[data-pdp-selling-plan]');
  const qtyInput = root.querySelector('[data-pdp-quantity]');
  let currentTier = 'monthly';
  let purchaseType = 'subscribe'; // 'subscribe' | 'one-time'

  /* ---- Purchase-type UI swap (matches live React conditional copy) ---- */
  const includeTitleEl = root.querySelector('.norvu-pdp__include-title');
  const includeUl = root.querySelector('.norvu-pdp__include ul');
  const includeLis = includeUl ? includeUl.querySelectorAll('li') : [];
  const includeCancelLi = includeLis[3] || null; // 4th li = "Pause or cancel anytime"
  // Replace the text node of the shipping <li> (1st), preserving its <svg>
  const setShippingCopy = (li, text) => {
    if (!li) return;
    // v21.2+: text lives inside .norvu-pdp__include-text span
    const textEl = li.querySelector('.norvu-pdp__include-text');
    if (textEl) {
      textEl.textContent = text;
      return;
    }
    // Legacy fallback: replace first non-empty direct text node
    for (const node of li.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        node.textContent = ' ' + text;
        return;
      }
    }
    li.appendChild(document.createTextNode(' ' + text));
  };
  function applyPurchaseTypeUI() {
    if (includeTitleEl) {
      includeTitleEl.textContent = purchaseType === 'subscribe'
        ? 'Your subscription includes:'
        : 'Every order includes:';
    }
    if (includeLis[0]) {
      setShippingCopy(includeLis[0],
        purchaseType === 'subscribe' ? 'Free shipping always' : 'Free shipping on orders over $75.00');
    }
    if (includeCancelLi) {
      includeCancelLi.style.display = purchaseType === 'subscribe' ? '' : 'none';
    }
    // Also flip the buy-once link active class so CSS can style it
    const buyOnceEl = root.querySelector('[data-buy-once]');
    if (buyOnceEl) buyOnceEl.classList.toggle('is-active', purchaseType === 'one-time');
  }

  tierEls.forEach(tier => tier.addEventListener('click', (e) => {
    if (e.target.tagName === 'A') return;
    currentTier = tier.dataset.tier;
    purchaseType = 'subscribe';
    tierEls.forEach(t => t.classList.toggle('is-active', t === tier));
    const r = tier.querySelector('input[type="radio"]');
    if (r) r.checked = true;
    applyPurchaseTypeUI();
    updatePricing();
  }));

  const planPool = Array.from(root.querySelectorAll('[data-plan-id]')).map(s => ({
    id: s.dataset.planId, name: (s.dataset.planName || '').toLowerCase()
  }));

  // Pinned plan IDs from the Norvu store's "Autoship and Save" plan group.
  // Pinned IDs win when present on the current product. If a product is on a
  // different plan group (rare — only happens if you intentionally configure
  // it), the regex helpers below resolve the right plan by name.
  const PINNED_PLAN_IDS = {
    monthly:   '692955611438', // "Deliver every month, 20% off"
    bimonthly: '692955644206', // "Deliver every 2 months, 20% off" — not currently exposed in UI
    quarterly: '692955676974'  // "Deliver every 3 months, 26% off"
  };

  // Returns true iff the pinned plan ID exists in the current product's pool
  const hasPinnedPlan = (id) => planPool.some(p => String(p.id) === String(id));

  // Match plan names robustly across Shopify Subscriptions / Recharge conventions:
  //   • Shopify Subscriptions: "Deliver every month, 20% off" / "Deliver every 3 months, 26% off"
  //   • Recharge:              "1 month subscription with 20% discount" / "3 month subscription with 26% discount"
  const findPlanId = (...needles) => {
    const tokens = needles.flat().map(n => String(n).toLowerCase());
    const p = planPool.find(x => tokens.every(t => x.name.includes(t)));
    return p ? p.id : '';
  };
  // "monthly" plan = name contains "month" but NOT "N month" where N≥2
  const findMonthlyPlanId = () => {
    if (hasPinnedPlan(PINNED_PLAN_IDS.monthly)) return PINNED_PLAN_IDS.monthly;
    const p = planPool.find(x => {
      if (!x.name.includes('month')) return false;
      if (/\b([2-9]|\d{2,})\s*month/.test(x.name)) return false;
      return true;
    });
    return p ? p.id : '';
  };
  const findQuarterlyPlanId = () => {
    if (hasPinnedPlan(PINNED_PLAN_IDS.quarterly)) return PINNED_PLAN_IDS.quarterly;
    const p = planPool.find(x => /\b3\s*month/.test(x.name));
    return p ? p.id : '';
  };

  function currentVariant() {
    return data.variants.find(v => String(v.id) === String(variantInput.value)) || data.variants[0];
  }

  function updatePricing() {
    const v = currentVariant();
    const base = v.price;
    const d1 = data.settings.discount1 || 20;
    const d3 = data.settings.discount3 || 26;

    const monthlyPrice = Math.round(base * (1 - d1 / 100));
    const quarterlyPrice = Math.round(base * 3 * (1 - d3 / 100));
    const quarterlyCompare = base * 3;

    const setIf = (sel, val) => { const el = root.querySelector(sel); if (el) el.textContent = val; };
    const setHtml = (sel, val) => { const el = root.querySelector(sel); if (el) el.innerHTML = val; };

    setIf('[data-tier-price="monthly"]', fmt(monthlyPrice));
    setHtml('[data-tier-compare="monthly"]', `<s>${fmt(base)}</s>`);
    setIf('[data-tier-price="quarterly"]', fmt(quarterlyPrice));
    setHtml('[data-tier-compare="quarterly"]', `<s>${fmt(quarterlyCompare)}</s>`);

    const onetimeEl = root.querySelector('[data-onetime-price]');
    if (onetimeEl) onetimeEl.textContent = fmt(base);

    // Sticky CTA: label + 2-decimal prices
    const stickyLabel = root.querySelector('[data-sticky-label]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyCompare = root.querySelector('[data-sticky-compare]');
    let stickyShown, stickyCmp, stickyLabelText;
    if (purchaseType === 'one-time') {
      stickyShown = base;
      stickyCmp = null;
      stickyLabelText = 'One-Time Purchase';
    } else if (currentTier === 'monthly') {
      stickyShown = monthlyPrice;
      stickyCmp = base;
      stickyLabelText = 'Monthly Delivery';
    } else {
      stickyShown = quarterlyPrice;
      stickyCmp = quarterlyCompare;
      stickyLabelText = '3-Month Delivery';
    }
    if (stickyLabel) stickyLabel.textContent = stickyLabelText;
    if (stickyPrice) stickyPrice.textContent = fmt2(stickyShown);
    if (stickyCompare) stickyCompare.textContent = stickyCmp ? fmt2(stickyCmp) : '';

    // Configure the hidden selling_plan input. For one-time purchases, keep it
    // disabled and empty so FormData omits the field on submit (which means
    // the cart will treat the line as one-time). For subscriptions, enable it
    // and set the right plan ID based on the active tier.
    if (purchaseType === 'one-time') {
      planInput.disabled = true;
      planInput.value = '';
    } else {
      planInput.disabled = false;
      if (currentTier === 'monthly') {
        planInput.value = findMonthlyPlanId();
        qtyInput.value = 1;
      } else {
        // 3-month tier: always add 3 units. If a real 3-month selling plan exists,
        // use it (Shopify Subscriptions delivers 3 units every 3 months bundled as
        // a single shipment). If only a 1-month plan exists, fall back to monthly
        // plan × 3 units so the customer still receives 3 bottles per delivery.
        const threeMonthId = findQuarterlyPlanId();
        if (threeMonthId) {
          planInput.value = threeMonthId;
        } else {
          planInput.value = findMonthlyPlanId();
        }
        qtyInput.value = 3;
      }
    }

    // Loyalty points: React formula (src/pages/ProductDetailTest.tsx:933-937)
    //   subscribe → ceil(subscribePrice) * 2
    //   one-time  → ceil(basePrice)      * 1
    // monthlyPrice/base are in cents.
    const ptsEl = root.querySelector('[data-points]');
    if (ptsEl) {
      const pts = purchaseType === 'subscribe'
        ? Math.ceil(monthlyPrice / 100) * 2
        : Math.ceil(base / 100);
      ptsEl.textContent = pts;
    }
  }

  /* ---- Buy Once link ----
     Single-shot one-time add. We flip into 'one-time' mode just long enough
     to submit the form, then immediately flip back to 'subscribe' so the
     next Add to Bag click (whether from the main CTA or the sticky bar)
     re-defaults to a monthly subscription. Without the reset, users who
     click Buy Once and then click Add to Bag would silently add another
     one-time unit instead of the subscription they actually want. */
  const buyOnce = root.querySelector('[data-buy-once]');
  if (buyOnce) buyOnce.addEventListener('click', (e) => {
    e.preventDefault();
    purchaseType = 'one-time';
    planInput.value = '';
    planInput.disabled = true;
    qtyInput.value = 1;
    applyPurchaseTypeUI();
    updatePricing();
    document.querySelector('[data-pdp-form]').requestSubmit();
    // Defer the reset to the next macrotask so the submit handler in cart.js
    // has fully finished reading FormData before we re-enable the planInput.
    // Otherwise a fast browser could re-enable the input before FormData
    // snapshots, and the submit would land as a subscription instead of one-time.
    setTimeout(() => {
      purchaseType = 'subscribe';
      applyPurchaseTypeUI();
      updatePricing();
    }, 0);
  });

  applyPurchaseTypeUI();
  updatePricing();

  /* ---- Add to cart: handled by cart.js global submit handler (see assets/cart.js).
     The form submission is intercepted there, FormData is parsed (id, quantity,
     selling_plan), and routed through NorvuCart.add() which checks for an existing
     line with the same variant+plan and bumps qty instead of creating duplicates. ---- */

  /* ---- Quick-add: also handled by cart.js global submit handler ---- */
  } catch (err) {
    console.error('Norvu PDP initialization failed', err);
  }
})();

/* ---- Free Gift modal ---- */
(function () {
  const dialog = document.querySelector('[data-gift-dialog]');
  if (!dialog) return;
  const openers = document.querySelectorAll('[data-gift-open]');
  const closers = dialog.querySelectorAll('[data-gift-close], [data-gift-confirm]');
  const options = dialog.querySelectorAll('[data-gift-option]');

  const open = () => {
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };
  const close = () => {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };

  openers.forEach(b => b.addEventListener('click', open));
  closers.forEach(b => b.addEventListener('click', close));

  // Click outside (backdrop) closes
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) close();
  });

  // Option selection (visual only — same gift default)
  options.forEach(opt => opt.addEventListener('click', () => {
    options.forEach(o => o.classList.toggle('is-selected', o === opt));
  }));
})();

/* ---- Sticky CTA bar — slides down from top after main Add to Bag scrolls past (matches live React) ---- */
(function () {
  const sticky = document.querySelector('[data-pdp-sticky]');
  const sentinel = document.getElementById('add-to-bag-sentinel');
  const mainCta = document.querySelector('[data-pdp-submit]');
  const stickyCta = document.querySelector('[data-pdp-sticky-cta]');
  if (!sticky || !mainCta || !stickyCta) return;
  const trigger = sentinel || mainCta;

  let ticking = false;
  const syncSticky = () => {
    const rect = trigger.getBoundingClientRect();
    // Show once the main CTA / sentinel has scrolled above the viewport
    const shouldShow = rect.bottom <= 0;
    sticky.classList.toggle('is-visible', shouldShow);
    sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    ticking = false;
  };
  const requestSync = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(syncSticky);
    }
  };

  syncSticky();
  window.addEventListener('scroll', requestSync, { passive: true });
  window.addEventListener('resize', requestSync);
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(requestSync, { threshold: [0, 1] });
    io.observe(trigger);
  }
  stickyCta.addEventListener('click', () => mainCta.click());
})();

/* ---- Accordions (single-open groups + animated open/close) ---- */
(function () {
  // For each [data-acc-group], coordinate so opening one closes its siblings.
  // For animation, we toggle a class .is-open and use CSS max-height transitions
  // on .norvu-acc__body (which wraps the content inside <details>).
  function initAccordionGroup(group) {
    const items = Array.from(group.querySelectorAll(':scope > details'));
    if (!items.length) return;

    const setOpenState = (details, open, animate) => {
      const body = details.querySelector(':scope > .norvu-acc__body');
      if (!body) {
        // No body wrapper — fall back to default toggle
        if (open) details.setAttribute('open', '');
        else details.removeAttribute('open');
        return;
      }
      if (open) {
        // Must have [open] for content to be in flow during the animation
        details.setAttribute('open', '');
        details.classList.add('is-open');
        // Lock max-height from current (0) to target (scrollHeight) for transition
        const target = body.scrollHeight;
        if (animate === false) {
          body.style.transition = 'none';
          body.style.maxHeight = 'none';
          // Force reflow then restore
          // eslint-disable-next-line no-unused-expressions
          body.offsetHeight;
          body.style.transition = '';
        } else {
          body.style.maxHeight = '0px';
          // eslint-disable-next-line no-unused-expressions
          body.offsetHeight;
          body.style.maxHeight = target + 'px';
          const onEnd = (e) => {
            if (e.propertyName !== 'max-height') return;
            body.style.maxHeight = 'none';
            body.removeEventListener('transitionend', onEnd);
          };
          body.addEventListener('transitionend', onEnd);
        }
      } else {
        details.classList.remove('is-open');
        if (animate === false) {
          body.style.transition = 'none';
          body.style.maxHeight = '0px';
          // eslint-disable-next-line no-unused-expressions
          body.offsetHeight;
          body.style.transition = '';
          details.removeAttribute('open');
        } else {
          // From current height down to 0
          const current = body.scrollHeight;
          body.style.maxHeight = current + 'px';
          // eslint-disable-next-line no-unused-expressions
          body.offsetHeight;
          body.style.maxHeight = '0px';
          const onEnd = (e) => {
            if (e.propertyName !== 'max-height') return;
            details.removeAttribute('open');
            body.removeEventListener('transitionend', onEnd);
          };
          body.addEventListener('transitionend', onEnd);
        }
      }
    };

    // Initial state: respect existing [open] attrs (only the first should be)
    items.forEach((d) => setOpenState(d, d.hasAttribute('open'), false));

    items.forEach((d) => {
      const summary = d.querySelector(':scope > summary');
      if (!summary) return;
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        const willOpen = !d.classList.contains('is-open');
        // Close every sibling first
        items.forEach((other) => {
          if (other !== d && other.classList.contains('is-open')) {
            setOpenState(other, false, true);
          }
        });
        setOpenState(d, willOpen, true);
      });
    });
  }

  document.querySelectorAll('[data-acc-group]').forEach(initAccordionGroup);

  // The FAQ list is hydrated by pdp.js after this script runs, so observe
  // for late-arriving [data-acc-group] nodes inside the FAQ container.
  const faqHost = document.querySelector('[data-meta="faqs"]');
  if (faqHost && 'MutationObserver' in window) {
    const mo = new MutationObserver(() => {
      faqHost.querySelectorAll('[data-acc-group]').forEach((g) => {
        if (g.dataset.accInit) return;
        g.dataset.accInit = '1';
        initAccordionGroup(g);
      });
    });
    mo.observe(faqHost, { childList: true, subtree: true });
  }
})();
